import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { Flip } from "react-toastify";
import "./App.scss";
import Navigation from "./navigation";
import { ToastContainer } from "react-toastify";
import LoadingSteps from "./components/Common/LoadingSteps/LoadingSteps";

const App = () => {
  return (
    <>
      <div className="App">
        <Navigation />
        <LoadingSteps />
        <ToastContainer theme="colored" transition={Flip} />
      </div>
    </>
  );
};
export default App;
